import { render, staticRenderFns } from "./PageSlide.vue?vue&type=template&id=5f69e130&scoped=true"
import script from "./PageSlide.vue?vue&type=script&lang=js"
export * from "./PageSlide.vue?vue&type=script&lang=js"
import style0 from "./PageSlide.vue?vue&type=style&index=0&id=5f69e130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f69e130",
  null
  
)

export default component.exports